import project from '../../../project'
import { ajaxSetup, getJSON } from 'jquery'
// import { Tracking } from '../../../../NodeModules/nnd-track-page'

var d3 = require('d3')

let APIlocation = `https://api.news.com.au/mm/dataset/NND${project.name}/`
if (process.env.NODE_ENV === 'testing') {
  APIlocation = `http://api.ni.news.com.au/mm/dataset/NND${project.name}/`
}

ajaxSetup({ cache: true })

export default {
  name: `nndrugbyworldcup2019barchart`,
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      database: [],
      dataPerc: {},
      totalVotes: 0
    }
  },
  methods: {
    getImgUrl (img, type) {
      return require('../../assets/images/' + img + '.' + type)
    },
    addVote () {
      const vm = this
      getJSON(`${APIlocation}select?callback=?`, {
        'format': 'json',
        'args': {
          'count': 100
        }
      }, data => {
        let thisVotes = 0
        for (let i = 0; i < data.items.length; i++) {
          if (vm.value.country !== null && vm.value.country.flag === data.items[i].country) {
            data.items[i].votes += 1
            thisVotes = data.items[i].votes
          }
          vm.value.data.totalVotes += data.items[i].votes
          vm.value.data.data.push(data.items[i])
        }

        // vm.createVis()

        let obj = {
          votes: thisVotes
        }

        getJSON(`${APIlocation}update?callback=?`, {
          'format': 'json',
          'args': {
            'where': [{ 'field': 'country', 'op': '=', 'value': `${vm.value.country.flag}` }],
            'values': obj
          }
        }, data => {
          vm.value.onceSelected = true
          vm.createVis()
        })
      })
    },
    createVis () {
      const vm = this
      var data = vm.value.data.data
      data.sort((a, b) => {
        if (!vm.value.data.dataPerc[a.country]) {
          let votesPerc = (a.votes * 100) / vm.value.data.totalVotes
          if (votesPerc < 1) votesPerc = 1
          vm.value.data.dataPerc[a.country] = Math.round(votesPerc)
        }
        if (!vm.value.data.dataPerc[b.country]) {
          let votesPerc = (b.votes * 100) / vm.value.data.totalVotes
          if (votesPerc < 1) votesPerc = 1
          vm.value.data.dataPerc[b.country] = Math.round(votesPerc)
        }
        if (a.votes > b.votes) {
          return 1
        } else if (b.votes > a.votes) {
          return -1
        } else {
          return 0
        }
      })
      // data.sort((a,b) => (a.votes > b.votes) ? 1 : ((b.votes > a.votes) ? -1 : 0))
      var margin = {top: 10, right: 25, bottom: 0, left: 110}
      var barHeight = 22
      var innerPadding = 0.5
      var elWidth = document.getElementById('nnd-chart').clientWidth
      var width = elWidth - margin.left - margin.right
      var height = (barHeight * data.length) - margin.top - margin.bottom
      var svg = d3.select('#nnd-chart').attr('width', width + margin.left + margin.right).attr('height', height)

      var x = d3.scaleLinear().range([10, width])
      var y = d3.scaleBand().range([height, margin.top])

      var g = svg.append('g')
      x.domain([0, d3.max(data, (d) => { return vm.value.data.dataPerc[d.country] })])
      y.domain(data.map((d) => { return d.countryname })).paddingInner(innerPadding)

      // g.append('g')
      //   .attr('class', 'x axis')
      //   .attr('transform', 'translate(' + margin.left + ', 0)')
      //   .call(
      //     d3.axisBottom(x)
      //       .ticks((elWidth > 400) ? 6 : 4)
      //       .tickFormat((d) => {
      //         return d + 'k'
      //       })
      //   )
      //   .call(g => g.selectAll('line').remove())

      g.append('g')
        .attr('class', 'y axis')
        .call(d3.axisLeft(y))
        .call(g => {
          g.selectAll('line').remove()
          g.select('path').remove()
        })
        .attr('transform', 'translate(' + margin.left + ', 0)')

      var barCont = g.append('g')
        .attr('class', 'nnd-barscont')
        .attr('transform', 'translate(0, 0)')

      var bars = barCont.selectAll('.bar')
        .data(data)
        .enter()
        .append('g')
        // .attr('class', 'bar')
        .attr('class', (d) => {
          return vm.whichBar(d)
        })

      bars.append('rect')
        .attr('width', 0)
        .attr('x', margin.left)
        .attr('height', y.bandwidth())
        .attr('y', (d) => { return y(d.countryname) })
        .attr('rx', 5)
        .transition()
        .delay(700)
        .duration(500)
        .attr('width', (d) => { return x(vm.value.data.dataPerc[d.country]) - margin.right + 10 })

      bars.append('text')
        .attr('class', 'label')
        .style('opacity', 0)
        .attr('y', (d) => {
          return y(d.countryname) + barHeight / 2 - 1
        })
        .attr('x', (d) => {
          let fromLeft = x(vm.value.data.dataPerc[d.country])
          return fromLeft + margin.left - margin.right + 5 + 10
        })
        .text((d) => {
          if (d.country === vm.value.country.flag) {
            vm.value.country.perc = vm.value.data.dataPerc[d.country]
          }
          return vm.value.data.dataPerc[d.country] + '%'
          // return parseInt(votesPerc, 10) + '%'
        })
        .transition()
        .delay(1000)
        .duration(500)
        .style('opacity', 1)
    },
    updateData () {
      const vm = this
      var bars = d3.selectAll('.bar')

      bars.attr('class', (d) => {
        return vm.whichBar(d)
      })
    },
    whichBar (d) {
      const vm = this
      if (d.country === vm.value.country.flag) {
        return 'bar bar-current'
      } else {
        return 'bar'
      }
    }
  },
  mounted () {
    const vm = this
    if (vm.value.onceSelected) {
      setTimeout(() => {
        vm.createVis()
      }, 500)
    } else {
      vm.addVote()
    }
    // setTimeout(() => {
    //   vm.createVis(vm.dataNew)
    // }, 500)
  },
  watch: {
    value: {
      handler: function () {
        this.updateData()
        // this.createVis()
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/barchart.js